import React from 'react';

function NextDays(props) {
    const thisWeather = props.weather[props.id]
    let date = (new Date(thisWeather.dt * 1000)).toString().split(' ');
    return(
        <div className="day future__info">
            <span className="date">{`${date[0]} ${date[1]} ${date[2]}`}</span>
            <span className="location">City: {props.city} <img alt="'Weather" src={`https://openweathermap.org/img/wn/${thisWeather.weather[0].icon}@2x.png`}></img></span>
            <span className="temp">
                Temperature
                <ul className="temp__data">
                    <li>Morning {thisWeather.temp.morn}{'\u00B0C'}</li>
                    <li>Day {thisWeather.temp.day}{'\u00B0C'}</li>
                    <li>Evening {thisWeather.temp.eve}{'\u00B0C'}</li>
                    <li>Night {thisWeather.temp.night}{'\u00B0C'}</li>
                </ul>
                Feels Like
                <ul className="temp__feels">
                    <li>{thisWeather.feels_like.morn}{'\u00B0C'}</li>
                    <li>{thisWeather.feels_like.day}{'\u00B0C'}</li>
                    <li>{thisWeather.feels_like.eve}{'\u00B0C'}</li>
                    <li>{thisWeather.feels_like.night}{'\u00B0C'}</li>
                </ul>
            </span>
            <span>Cloudiness {thisWeather.clouds} %</span>
            <span>Humidity {thisWeather.humidity} %</span>
            <span>{`Wind speed: ${thisWeather.wind_speed} metre/sec`}</span>
        </div>
    )
}

export default NextDays;